import React__default, { forwardRef } from 'react';
import { Row, Col, Button } from 'reactstrap';
import Form from '../Form.js';
import RowCreator from './RowCreator.js';
import { createInitialValues, createValidationSchema } from './validations.js';

function FormBuilder(props, ref) {
    const { formConfig, externalData, onSubmit, onFormFieldsChange, onFormBlur, initialValues, validationSchema, formButtons, children, submitButtonText, submitButtonType, submitButtonClick, hideSubmitButton, scrollToError, mode, reValidateMode, errorCallback, CustomFormComponents, exposeSeparateFieldValue } = props;
    return (React__default.createElement(Form, { ref: ref, onSubmit: onSubmit, onFormBlur: onFormBlur, initialValues: createInitialValues(formConfig.rows, formConfig.keySuffix, initialValues), onFormFieldsChange: onFormFieldsChange, validationSchema: validationSchema || createValidationSchema(formConfig.rows, formConfig.keySuffix), exposeSeparateFieldValue: exposeSeparateFieldValue, yupContext: externalData?.yupContext || {}, scrollToError: scrollToError, mode: mode, reValidateMode: reValidateMode, errorCallback: errorCallback },
        formConfig.rows.length > 0 &&
            formConfig.rows.map(row => (React__default.createElement(RowCreator, { key: row.key, elements: row.elements, CustomFormComponents: CustomFormComponents, keySuffix: formConfig.keySuffix, externalData: externalData, 
                // eslint-disable-next-line react/no-children-prop
                children: children }))),
        formButtons ||
            (!hideSubmitButton ? (React__default.createElement(Row, { className: "form-buttons mt-4" },
                React__default.createElement(Col, { className: "d-flex justify-content-end" },
                    React__default.createElement(Button, { color: "primary", type: submitButtonType || 'submit', onClick: (e) => {
                            if (submitButtonClick) {
                                e.preventDefault();
                                submitButtonClick(e);
                            }
                        } }, submitButtonText || 'Submit')))) : null)));
}
var FormBuilder$1 = forwardRef(FormBuilder);

export { FormBuilder$1 as default };
//# sourceMappingURL=FormBuilder.js.map
